import { post, get, whitelistPost, whitelistGet } from "../common/http.services";

export function signin(authModel: any, appContext: any, success: any, error: any) {
    return whitelistPost(`/user/signin`, authModel, appContext, success, error);
}

export function changePassword(oldPassword: any, newPassword: any, appContext: any, success: any, error: any) {
    return post(`/user/changepassword?oldPassword=${oldPassword}&newPassword=${newPassword}`, null, appContext, success, error);
}

export function saveUser(userModel: any, appContext: any, success: any, error: any) {
    return post(`/user`, userModel, appContext, success, error);
}

export function defaultPassword(userId: any, password: any, appContext: any, success: any, error: any) {
    return post(`/user/defaultpassword?userId=${userId}&password=${password}`, null, appContext, success, error);
}

export function getAllUsers(pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return get(`/user/page?page=${pageNumber}&size=${pageSize}&sort=name,asc`, appContext, success, error);
}

export function getOwnershipBasedUsers(ownership: any, appContext: any, success: any, error: any) {
    return get(`/user?ownership=${ownership}`, appContext, success, error);
}

export function getActiveUsers(appContext: any, success: any, error: any) {
    return get(`/user/getactive`, appContext, success, error);
}

export function getUserById(usrerId: any, appContext: any, success: any, error: any) {
    return get(`/user/findbyid?id=${usrerId}`, appContext, success, error);
}

export function getCurrentUser(appContext: any, success: any, error: any) {
    return whitelistGet("/user/me", appContext, success, error);
}
